import React, { useState, useEffect, ReactNode } from "react";
import styles from "./ActionBarButton.module.scss";
import { useTheme } from "hooks/useSingleton";
import { Button } from "@factorearth/component-library";
interface Props {
	children: ReactNode;
	color?: string;
	disabled?: boolean;
	id?: string;
	onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	background?: string;
	outlinedButton?: boolean;
}

const ActionBarButton = (props: Props) => {
	const { color, disabled, id, onClick, children, outlinedButton } = props;

	let theme = useTheme();

	const [backgroundColor, setBackgroundColor] = useState(theme.background.tertiary);
	const [textColor, setTextColor] = useState(theme.text.secondary);
	const [border, setBorder] = useState(theme.text.secondary);

	useEffect(() => {
		if (disabled) {
			setBackgroundColor(theme.background.secondary);
			setTextColor(theme.text.secondary);
		} else if (color) {
			setBackgroundColor(color);
			setTextColor("white");
		} else if (outlinedButton) {
			setBackgroundColor("transparent");
			setTextColor(theme.text.primary);
			setBorder(`1px solid ${theme.border.primary}`);
		} else {
			setBackgroundColor(theme.text.tertiary);
			setTextColor(theme.background.primary);
		}
	}, [color, disabled]);

	return (
		<>
			<Button colorPalette={theme} type="submit" id={id} onClick={onClick} className={styles.actionBarButton} variant="outlined" disabled={disabled}>
				{children}
			</Button>
		</>
	);
};

export default ActionBarButton;
